export default "__VITE_ASSET__u3lH$kQo__"